import React from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import client from '../../graphql/client';
import { useStore } from '../../utils';
import Frame from './Frame';
import { AuthProvider } from '../Auth/AuthProvider';
import { StoreProvider } from './StoreProvider';

const App = (): React.JSX.Element => {
    const store = useStore();

    return (
        <ApolloProvider client={client}>
            <BrowserRouter>
                <StoreProvider store={store}>
                    <AuthProvider>
                        <Frame />
                        <ToastContainer position="top-right" autoClose={2500} closeButton />
                    </AuthProvider>
                </StoreProvider>
            </BrowserRouter>
        </ApolloProvider>
    );
};

export default App;
